import { InfluxChartBuilder } from '@/composables/charts/influx-charts/chart-builders/InfluxChartBuilder'
import { CompiledInfluxQueryObjectWithSingleQuery, InfluxQuery } from '@/composables/charts/influx-charts/query-builders/InfluxTypes'
import { CompiledChartTimeSetup } from '@/composables/charts/influx-charts/chart-serialization/ChartTimeSetup'
import { WhereClauses } from '@/composables/charts/influx-charts/chart-serialization/WhereClauses'

export abstract class AbstractInfluxLineChartBuilder extends InfluxChartBuilder {
  getRenderChartType(): string {
    return 'line'
  }

  buildQueryForSingleQuery(measurement: string, field: string): CompiledInfluxQueryObjectWithSingleQuery {
    const compiledTimeSetup: CompiledChartTimeSetup = this.timeSetup.compile()
    const query: InfluxQuery = {
      time: {
        start: compiledTimeSetup.start,
        end: compiledTimeSetup.end,
      },
      timeResolution: compiledTimeSetup.timeResolution + 'ms',
      columns: {
        [field]: this.xAggregation + '@y',
      },
    }

    const where: WhereClauses = {}
    const groupByTags: string[] = []
    const customPredicates = []
    if (this.whereClauses) Object.assign(where, this.whereClauses)
    if (this.transientWhereClauses) Object.assign(where, this.transientWhereClauses)

    if (this.tagSelectors)
      for (const tagSelector of this.tagSelectors) {
        if (!tagSelector.useAll && tagSelector.specificValues && tagSelector.specificValues.length > 0)
          where[tagSelector.tag] = tagSelector.specificValues
        if (tagSelector.groupByValues) groupByTags.push(tagSelector.tag)
        if (!tagSelector.allowEmptyValues) customPredicates.push(`${tagSelector.tag} != ''`)
      }
    if (this.transientTagSelectors)
      for (const tagSelector of this.transientTagSelectors) {
        if (!tagSelector.useAll && tagSelector.specificValues && tagSelector.specificValues.length > 0)
          where[tagSelector.tag] = tagSelector.specificValues
        if (tagSelector.groupByValues) groupByTags.push(tagSelector.tag)
        if (!tagSelector.allowEmptyValues) customPredicates.push(`${tagSelector.tag} != ''`)
      }

    if (Object.keys(where).length > 0) {
      query.where = where
    }

    if (this.groupByTags) groupByTags.push(...this.groupByTags)
    if (this.transientGroupByTags) groupByTags.push(...this.transientGroupByTags)
    if (groupByTags.length > 0) {
      query.groupByTags = [...new Set(groupByTags)]
    }

    if (this.customPredicates) customPredicates.push(...this.customPredicates)
    if (this.transientCustomPredicates) customPredicates.push(...this.transientCustomPredicates)

    if (customPredicates.length > 0) {
      query.customPredicates = [...new Set(customPredicates)]
    }
    if (this.fill !== undefined) {
      query.fill = this.fill
    }
    return {
      path: '/api/data/' + measurement,
      query: query,
    }
  }
}
